import manageOpenAIResponse from "../../../../actions/aiFeatures/OpenAI/manageOpenAIResponse";
import renterPrompt from "../../../../lib/AIFeatures/Prompt/renterPrompt";

const submit = async (values, dispatch) => {
    try {
        let prompt;
        if (values?.isMessagePrompt === "contactHost") {
            const { contactHostMessage } = renterPrompt
            prompt = contactHostMessage({
                tripStart: values.checkIn,
                tripEnd: values.checkOut,
                content: values.aiMessage,
                reasonForTravel: values.travelReason,
                hostName: values.hostName,
                language: values.language
            });
        } else {
            const { rentRequestMessage } = renterPrompt
            prompt = rentRequestMessage({
                tripStart: values.checkIn,
                tripEnd: values.checkOut,
                content: values.aiMessage,
                travelReason: values.travelReason,
                hostName: values.hostName,
                language: values.language
            });
        }
        await dispatch(manageOpenAIResponse({ name: 'reservationMessage', prompt }));
    } catch (error) {
        console.log(error, "error")
    }
}
export default submit